import { teamMembers } from '@/mocks/team';

const memberImages: Record<string, string> = {
  'team-1': 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20therapist%20portrait%20in%20warm%20lighting%2C%20soft%20neutral%20background%2C%20kind%20and%20trustworthy%20expression%2C%20modern%20professional%20attire%2C%20warm%20beige%20cream%20tones%2C%20minimalist%20studio%20portrait%2C%20clinical%20psychology%20counseling%20aesthetic%2C%20soft%20bokeh%2C%20healing%20and%20calm%20atmosphere&width=400&height=500&seq=team-lin-wanqing&orientation=portrait',
  'team-2': 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20doctor%20portrait%20in%20warm%20lighting%2C%20soft%20neutral%20background%2C%20kind%20and%20knowledgeable%20expression%2C%20modern%20medical%20professional%20attire%2C%20warm%20beige%20cream%20tones%2C%20minimalist%20studio%20portrait%2C%20urology%20andrology%20specialist%20aesthetic%2C%20soft%20bokeh%2C%20healing%20atmosphere&width=400&height=500&seq=team-chen-bowen&orientation=portrait',
  'team-3': 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20family%20therapist%20portrait%20in%20warm%20lighting%2C%20soft%20neutral%20background%2C%20gentle%20and%20approachable%20expression%2C%20modern%20professional%20attire%2C%20warm%20beige%20cream%20tones%2C%20minimalist%20studio%20portrait%2C%20family%20counseling%20aesthetic%2C%20soft%20bokeh%2C%20healing%20atmosphere&width=400&height=500&seq=team-su-yutong&orientation=portrait',
  'team-4': 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20psychologist%20portrait%20in%20warm%20lighting%2C%20soft%20neutral%20background%2C%20thoughtful%20and%20empathetic%20expression%2C%20modern%20professional%20attire%2C%20warm%20beige%20cream%20tones%2C%20minimalist%20studio%20portrait%2C%20clinical%20psychology%20aesthetic%2C%20soft%20bokeh%2C%20healing%20atmosphere&width=400&height=500&seq=team-zhou-mingyuan&orientation=portrait',
};

export default function TeamSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          专业顾问团队
        </h2>
        <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
          每一位顾问都经过严格筛选，拥有丰富的临床经验和温暖的咨询风格
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {teamMembers.map((member) => (
          <div
            key={member.id}
            className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden group"
          >
            <div className="relative h-56 overflow-hidden">
              <img
                src={memberImages[member.id]}
                alt={member.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-lg font-semibold text-foreground-900">{member.name}</h3>
              <p className="text-sm text-primary-600 font-medium mb-1">{member.title}</p>
              <p className="text-xs text-foreground-500 mb-3">{member.credentials}</p>
              <p className="text-xs text-foreground-500 mb-3">{member.experience}</p>
              <div className="flex flex-wrap gap-1.5">
                {member.specialty.map((s) => (
                  <span
                    key={s}
                    className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}